/** @type {Styles} */

export const styles = {
  wrapper: {
    paddingY: 2.5,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    minWidth: 0,
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  dot: {
    marginX: 0.5,
  },
  descriptionText: {
    marginTop: 0.25,
  },
  content: {
    marginLeft: 6,
  },
}
